import { withChartLayout } from 'components/common';
import NutritionHydration from 'components/features/chart/basic-nursing-care/nutrition-hydration/NutritionHydration';

const NutritionHydrationPage = withChartLayout('Nutrition and Hydration')(NutritionHydration);
export default NutritionHydrationPage;
